<template>
    <div :class="['ras-quiz', { 'ras-quiz--no-image': !icons }]">
        <label
            v-for="(option, i) of options"
            :key="i"
            :class="[
                'ras-quiz-button',
                {
                    'ras-quiz-button--checked': checked.some(
                        (x) => x == option
                    ),
                    'ras-quiz-button--square': icons,
                    'ras-quiz-button--disabled': maxed
                }
            ]"
        >
            <img v-if="icons" :src="`images/svgs/${option}.svg`" />
            <span v-else></span>
            <span class="ras-heading ras-quiz-button__label" :for="option">{{
                option
            }}</span>
            <input
                :id="option"
                v-model="checked"
                type="checkbox"
                :value="option"
                @change="onChange"
                :disabled="
                    checked.length > max - 1 && checked.indexOf(option) === -1
                "
            />
        </label>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            required: false,
            default: () => []
        },
        icons: {
            type: Boolean,
            required: false,
            default: false
        },
        min: {
            type: Number,
            required: false,
            default: 1
        },
        max: {
            type: Number,
            required: false,
            default: 5
        },
        selected: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    data: () => ({
        checked: [],
        canProgress: false,
        maxed: false
    }),
    methods: {
        onChange() {
            this.$emit('input', this.checked)
        }
    },
    watch: {
        checked(val) {
            this.maxed = val.length >= this.max
            this.canProgress = val.length >= this.min
        },
        canProgress(val) {
            this.$emit('can-progress', val)
        },
        selected(val) {
            this.checked = val
        }
    }
}
</script>

<style lang="scss">
.ras-checkbox {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .ras-checkbox-button {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: $c-inactive;
        width: 260px;
        height: 145px;
        cursor: pointer;
        margin: 15px;

        &:hover {
            background-color: $c-hover;
        }

        img {
            max-width: 100px;
            margin-bottom: 50px;
        }

        input {
            appearance: none;
            opacity: 0;
        }

        &__label {
            color: $white;
        }

        &--checked {
            background-color: $c-selected;

            &:hover {
                background-color: $c-selected;
            }
        }

        &--square {
            height: 260px;
        }
    }
}
</style>
